import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from './api'


const initialState = {
  ...baseModelState,
}


export const cardTypeBenefit = createSlice({
  name: 'cardTypeBenefit',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateCardTypeBenefit);
  },
});

export default cardTypeBenefit.reducer;

export const CardTypeBenefitActions = cardTypeBenefit.actions;
